/**
 * Tiny haptic-feedback helper. Uses the Vibration API where it exists
 * (Android Chrome / Firefox); it is a silent no-op on iOS Safari and desktop.
 */
const PATTERNS = {
  tick: 8, // selection change, snapping
  light: 12, // tap on a toggle, tab change
  medium: 22, // long-press recognised, drag picked up
  heavy: 35,
  success: [12, 40, 18],
  error: [30, 50, 30],
};

export function haptic(kind = "light") {
  try {
    if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return;
    // Chrome blocks (and logs an error for) vibrations before the first tap on the page.
    if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    navigator.vibrate(PATTERNS[kind] ?? PATTERNS.light);
  } catch {
    /* Vibration can throw when the page isn't user-activated — never fatal. */
  }
}

export default haptic;
